<template>
  <card-view :loading="loadState.isLoading">
    <template v-slot:content>
      <v-row v-if="user!=null && user.userProfile!=null" class="ma-0">
        <v-col cols="4">
          <v-row>
            <v-col cols="12" class="text-center">
              <v-badge icon="mdi-upload" color="grey" offset-x="28" offset-y="28" bordered>
                <v-btn @click="userAvatarUploadOpen=true" width="128" height="128" color="grey lighten-3" fab elevation="0">
                    <v-avatar size="128">
                      <v-icon v-if="user.imageUrl==null" size="64" color="grey">mdi-account</v-icon>
                      <img v-else :src="user.imageUrl">
                    </v-avatar>
                </v-btn>
              </v-badge>
              <uploader
                  :dialog.sync="userAvatarUploadOpen"
                  :multiple="false"
                  :url="'/api/user/'+$router.currentRoute.params.id+'/image/'"
                  @uploadComplete="(v)=>v.length>0 ? user.imageUrl=v[0] : null"
              />
            </v-col>
            <v-col cols="12">
              <tag-add :entityId="user.id" entityType="user"/>
            </v-col>
            <v-col cols="12" class="subtitle-2 pb-0">Быстрые действия</v-col>
            <v-col cols="12">
              <v-btn :disabled="loadState.isLoading" block depressed @click="visitCreate"><v-icon class="pr-2">mdi-pencil-outline</v-icon>Создать визит<v-spacer /></v-btn>
            </v-col>
            <v-col cols="12" class="subtitle-2">Связь</v-col>
            <v-col cols="12">
              <call-phone v-if="!$tools.isEmpty(user.phone)" :disabled="loadState.isLoading" :phone="user.phone" big block title="Позвонить"  class=" mb-2"/>
              <call-phone v-if="!$tools.isEmpty(user.userProfile.phone1)" :disabled="loadState.isLoading" :phone="user.userProfile.phone1" big block title="Позвонить (доп.)"  class="mb-2"/>
              <v-btn
                  v-if="!$tools.isEmpty(user.phone) || !$tools.isEmpty(user.userProfile.phone1)"
                  @click="
                    $tools.storageSet(
                        'contactCenter_chat_search',
                        ($tools.isEmpty(user.phone) ? '': $tools.phoneFormat(user.phone, true))+
                        ($tools.isEmpty(user.userProfile.phone1) ? '' : ','+$tools.phoneFormat(user.userProfile.phone1, true))+
                        ($tools.isEmpty(user.userProfile.whatsapp) ? '' : ','+$tools.phoneFormat(user.userProfile.whatsapp, true))
                    );$router.push('/contactCenter/chat/')
                  "
                   :disabled="loadState.isLoading"
                   class="mb-2" block depressed
              >
                <v-icon class="pr-2">mdi-message-text-outline</v-icon>Чат<v-spacer />
              </v-btn>
              <v-btn v-if="user.userProfile.email!=null && user.userProfile.email!=''" :disabled="loadState.isLoading" class="mb-2" block depressed @click="openUrl('mailto:'+user.userProfile.email)"><v-icon class="pr-2">mdi-email-outline</v-icon>E-mail<v-spacer /></v-btn>
              <v-btn v-if="user.userProfile.whatsapp!=null && user.userProfile.whatsapp!='' || isWFromPhone" :disabled="loadState.isLoading" class="mb-2" block depressed @click="openUrl('https://wa.me/'+encodeURIComponent(isWFromPhone ? user.phone : user.userProfile.whatsapp), true)"><v-icon class="pr-2">mdi-whatsapp</v-icon>whatsapp<v-spacer /></v-btn>
              <v-btn v-if="user.userProfile.telegram!=null && user.userProfile.telegram!='' || isTFromPhone" :disabled="loadState.isLoading" class="mb-2" block depressed @click="openUrl('https://t.me/'+encodeURIComponent(isTFromPhone ? user.phone : user.userProfile.telegram), true)"><v-icon class="pr-2">mdi-telegram</v-icon>telegram<v-spacer /></v-btn>
              <v-btn v-if="user.userProfile.instagram!=null && user.userProfile.instagram!=''" :disabled="loadState.isLoading" class="mb-2" block depressed @click="openUrl('https://instagram.com/'+encodeURIComponent(user.userProfile.instagram)+'/', true)"><v-icon class="pr-2">mdi-instagram</v-icon>instagram<v-spacer /></v-btn>
              <v-btn v-if="user.userProfile.vk!=null && user.userProfile.vk!=''" :disabled="loadState.isLoading" class="mb-2" block depressed @click="openUrl('https://vk.com/'+encodeURIComponent(user.userProfile.vk), true)"><v-icon class="pr-2">mdi-vk</v-icon>vk<v-spacer /></v-btn>
            </v-col>
            <!-- УДАЛИТЬ! -->
            <v-col cols="12">Polibase id: {{user.userProfile.oid}}</v-col>
            <!-- УДАЛИТЬ! -->


          </v-row>
        </v-col>
        <v-col md="8">
          <UserProfileCardForm :user.sync="user"/>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn depressed color="error" @click="deleteState.modalOpen()" class="mr-2"><v-icon class="pr-2">mdi-trash-can-outline</v-icon>Удалить</v-btn>
          <v-dialog v-model="deleteState.isModalOpen" max-width="250">
            <v-card>
              <v-card-title>Удалить?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="deleteState.modalClose()">Отмена</v-btn>
                <v-btn color="primary" text @click="deleteAction" :loading="deleteState.isLoading">Удалить</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn depressed color="primary" @click="updateState.modalOpen()"><v-icon class="pr-2">mdi-content-save</v-icon>Сохранить</v-btn>
          <v-dialog v-model="updateState.isModalOpen" max-width="250">
            <v-card>
              <v-card-title>Сохранить?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="updateState.modalClose()">Отмена</v-btn>
                <v-btn color="primary" text @click="save" :loading="updateState.isLoading">Сохранить</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </template>
  </card-view>
</template>

<script>
import moment from "moment";
import State from "@/plugins/state";
import UserProfileCardForm from "@/views/User/UserProfileCardForm";
import CardView from "@/components/CardView";
import CallPhone from "@/components/CallPhone";
import axios from "axios";
import Api from "@/Api";
import Uploader from "@/components/Uploader.vue";
// import Chip from "../../componentsV2/base/Chip.vue";
import TagAdd from "@/views/Tag/components/TagAdd.vue";

import {
  Entity_User, 
  Entity_UserProfile, 
  Entity_PassType,
  Entity_UserSpec,
  Entity_Spec,
  Entity_Insur
} from "../../../EntityStoreCacheService";

export default {
  components: {Uploader,  CallPhone, CardView, UserProfileCardForm, TagAdd},
  data: () => ({
    user: null,
    loadState: new State(),
    updateState: new State(),
    deleteState: new State(),
    panelOpen: 0,
    promoSources: [],

    isWFromPhone: false,
    isTFromPhone: false,

    userAvatarUploadOpen: null,
  }),
  mounted() {
    this.load();
    this.panelOpen = 0;
  },
  computed: {
    birth: {
      get: function() {
        return moment(this.user.userProfile.birth, 'YYYY-MM-DD').format('DD.MM.YYYY');
      },
      set: function(birth) {
        let d = moment(birth, 'DD.MM.YYYY')
        if (birth.length===10 && d.isValid())
          this.user.userProfile.birth = d.format('YYYY-MM-DD');
      }
    },
    pasDate: {
      get: function() {
        return moment(this.user.userProfile.pasDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
      },
      set: function(pasDate) {
        let d = moment(pasDate, 'DD.MM.YYYY')
        if (pasDate.length===10 && d.isValid())
          this.user.userProfile.pasDate = d.format('YYYY-MM-DD');
      }
    }
  },
  methods:{
    openUrl: function(url, isNewTab){
      if (isNewTab)
        window.open(url);
      else
        window.location.href = url;
    },
    load: async function(){
      this.loadState.stateLoading();

      axios.get(Api.host+'/user/promoSource/')
      .then(r =>{
        this.promoSources = r.data
      });

      new Entity_User()
        .selects(Entity_User.id)
        .selects(Entity_User.firstName)
        .selects(Entity_User.lastName)
        .selects(Entity_User.secondName)
        .selects(Entity_User.phone)
        .selects(Entity_User.type)
        .selects(Entity_User.status)
        .selects(Entity_User.perms)
        .virtual(Entity_User.virtual_permsPossibles)
        .selects(Entity_User.imageUrl)
        .selects(Entity_User.signatureUrl)
        .selects([Entity_User.userProfile,Entity_UserProfile.id].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.gender].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.birth].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.phone1].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.POANumber].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.phoneCompany].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.email].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.comment].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.commentAdd].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.experience].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.jobDesc].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.rank].join('.'))   
        .selects([Entity_User.userProfile,Entity_UserProfile.education].join('.'))      
        .selects([Entity_User.userProfile,Entity_UserProfile.professional].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.work].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.description].join('.'))   
        .selects([Entity_User.userProfile,Entity_UserProfile.workOrgName].join('.'))   
        .selects([Entity_User.userProfile,Entity_UserProfile.workOrgPhone].join('.'))   
        .selects([Entity_User.userProfile,Entity_UserProfile.isLeadBonus].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.isDialogForExternal].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.whatsapp].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.telegram].join('.'))  
        .selects([Entity_User.userProfile,Entity_UserProfile.instagram].join('.'))  
        .selects([Entity_User.userProfile,Entity_UserProfile.vk].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.promoSource].join('.'))      
        .selects([Entity_User.userProfile,Entity_UserProfile.resAddrStreet].join('.'))   
        .selects([Entity_User.userProfile,Entity_UserProfile.resAddrEntrance].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.resAddrIntercom].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.resAddrFloor].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.resAddrRoom].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.pasSeries].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.pasNumber].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.pasBy].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.pasDate].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.pasAddrStreet].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.pasAddrRoom].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.passType,Entity_PassType.id].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.passType,Entity_PassType.name].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.passType,Entity_PassType.code].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.inn].join('.'))  
        .selects([Entity_User.userProfile,Entity_UserProfile.snils].join('.'))  
        .selects([Entity_User.userProfile,Entity_UserProfile.medCardNumber].join('.'))  
        .selects([Entity_User.userProfile,Entity_UserProfile.medCardStore].join('.'))  
        .selects([Entity_User.userProfile,Entity_UserProfile.medCardStorePosition].join('.'))  
        .selects([Entity_User.userProfile,Entity_UserProfile.insurOms,Entity_Insur.id].join('.'))  
        .selects([Entity_User.userProfile,Entity_UserProfile.insurOms,Entity_Insur.name].join('.'))  
        .selects([Entity_User.userProfile,Entity_UserProfile.insurOmsEnd].join('.'))   
        .selects([Entity_User.userProfile,Entity_UserProfile.insurOmsDes].join('.'))   
        .selects([Entity_User.userProfile,Entity_UserProfile.insurDms,Entity_Insur.id].join('.'))  
        .selects([Entity_User.userProfile,Entity_UserProfile.insurDms,Entity_Insur.name].join('.'))  
        .selects([Entity_User.userProfile,Entity_UserProfile.insurDmsEnd].join('.'))   
        .selects([Entity_User.userProfile,Entity_UserProfile.insurDmsDes].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.contractNumber].join('.'))
        .selects([Entity_User.userProfile,Entity_UserProfile.contractDate].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.certificateText].join('.')) 
        .selects([Entity_User.userProfile,Entity_UserProfile.oid].join('.'))       
        .selects([Entity_User.userProfile,Entity_UserProfile.discount].join('.'))      
        .selects([Entity_User.userProfile,Entity_UserProfile.isSelfEdit].join('.'))    
        .selects([Entity_User.userSpecs,Entity_UserSpec.id].join('.')) 
        .selects([Entity_User.userSpecs,Entity_UserSpec.spec,Entity_Spec.id].join('.'))  
        .selects([Entity_User.userSpecs,Entity_UserSpec.spec,Entity_Spec.name].join('.'))  
        .filterAnd([Entity_User.entity,Entity_User.id].join('.')+'=?',parseInt(this.$router.currentRoute.params.id))
        .addStateCallback((v)=> this.loadState.setRequestBuilderState(v))
        .request((r)=>{
          this.user = r.items[0];
          if (this.user!=null) {
            this.isWFromPhone = this.user.phone===this.user.userProfile.whatsapp;
            this.isTFromPhone = this.user.phone===this.user.userProfile.telegram;
          }
        }, (e)=>{
          this.loadState.stateError();
          console.error(e.response.data.message);
        })


      // axios.get(Api.host+'/user/'+this.$route.params.id+'/')
      //   .then(r =>{
      //     this.user = r.data;
      //     if (this.user!=null) {
      //       this.isWFromPhone = this.user.phone===this.user.userProfile.whatsapp;
      //       this.isTFromPhone = this.user.phone===this.user.userProfile.telegram;
      //     }
      //     this.loadState.stateSuccess();
      //   })
      //   .catch((e) =>{
      //     this.loadState.stateError();
      //     console.log(e)
      //   });
    },
    save: function(){
      this.updateState.stateLoading();
      let data = this.user;

      delete data.$id;
      delete data.userProfile.$id;
      delete data.userProfile.id;
      data.userProfile.whatsapp = this.isWFromPhone ? data.phone : data.userProfile.whatsapp;
      data.userProfile.telegram = this.isTFromPhone ? data.phone : data.userProfile.telegram;

      if (data.userProfile.birth)
        data.userProfile.birth = moment(data.userProfile.birth).format('YYYY-MM-DD')
      if (data.userProfile.pasDate)
        data.userProfile.pasDate = moment(data.userProfile.pasDate).format('YYYY-MM-DD')

      //Если адрес проживания не заполнен, заполняем из адреса регистрации
      if (!data.userProfile.resAddrStreet) {
        data.userProfile.resAddrStreet = data.userProfile.pasAddrStreet 
        data.userProfile.resAddrRoom = data.userProfile.pasAddrRoom 
      }

      axios.put(Api.host+'/user/'+this.$route.params.id+'/?type=client', data)
        .then(r =>{
          this.user = r.data;
          if(parseInt(this.$route.params.id)===this.$store.state.user.id)
            this.$store.state.user = this.user;
          if (this.user!=null) {
            this.isWFromPhone = this.user.phone===this.user.userProfile.whatsapp;
            this.isTFromPhone = this.user.phone===this.user.userProfile.telegram;
          }
          this.updateState.stateSuccess();
          this.updateState.modalClose();
          this.$store.commit('alertSuccess', 'Успешно сохранено');

          this.$router.push({path:'../../../user/'+this.user.type+'/'+this.user.id+'/'});
        })
        .catch((e) =>{
          this.updateState.stateError();
          console.error(e.response.data.message);
          this.updateState.modalClose();

        });
    },
    deleteAction(){
      this.deleteState.stateLoading();
      axios.delete(Api.host+'/user/'+this.$route.params.id+'/')
        .then(() =>{
          this.deleteState.stateSuccess();
          this.deleteState.modalClose();
          this.$store.commit('alertSuccess', 'Успешно удалено');
          this.$router.push({path:'../../'});
        })
        .catch((e) =>{
          this.deleteState.stateError();
          this.deleteState.modalClose();
          console.error(e.response.data.message);
        });
    },
    visitCreate() {
      window.open('/panel/visit?userId='+this.user.id, '_blank');
    }
  },
  filters: {
    dateYears: function(date){
      if (date==null) return '';
      if (date.length!==10) return '';
      return '('+moment(date, 'DD.MM.YYYY').fromNow(true)+')';
    },
  },
  destroyed() {
  }
}
</script>